<template>
  <div>

    <b-row class="justify-content-center">
      <b-col md="8">
        <b-card-group>
          <b-card no-body class="p-4">
            <b-card-body>
              <b-form>
                <!--                <table v-if="th==1" align="center" width="70%" border="0">-->
                <!--                  <tr><td colspan="3">&nbsp;&nbsp;</td></tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="3" align="center"><font color="red" size="+2">เปิดระบบการลงทะเบียน</font></td>-->
                <!--                  </tr>-->
                <!--                  <tr><td colspan="3">&nbsp;&nbsp;</td></tr>-->
                <!--                  <tr>-->
                <!--                    <td width="5%" align="right">1.</td>-->
                <!--                    <td colspan="2">&nbsp;สอบถามข้อมูลเพิมเติมการฝึกซ้อมบัณฑิต ในวันและเวลาปฏิบัติงาน (วันจันทร์-วันศุกร์-->
                <!--                      เวลา 08.00 -16.00 น.)-->
                <!--                    </td>-->

                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="2 " width="10%" align="right">1.1</td>-->
                <!--                    <td>&nbsp;ส่วนพัฒนานักศึกษา โทรศัพท์ 0-5391-6377, 0-5391-6360</td>-->
                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td width="5%" align="right">2.</td>-->
                <!--                    <td colspan="2 ">&nbsp;การขอรับใบปริญญาบัตรในวันและเวลาปฏิบัติงาน (วันจันทร์-วันศุกร์ เวลา 08.00-->
                <!--                      -16.00 น.)-->
                <!--                    </td>-->
                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="2 " width="10%" align="right">2.1</td>-->
                <!--                    <td>&nbsp;ส่วนทะเบียนและประมวลผล โทรศัพท์ 0-5391-6433 , 0-5391-6546, 0-5391-6547</td>-->
                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td width="5%" align="right">3.</td>-->
                <!--                    <td colspan="2 ">&nbsp;สอบถามรายละเอียดการจองภาพ พิธีพระราชทานรับปริญญาเพิ่มเติม ที่สมาคมนักศึกษาเก่ามหาวิทยาลัยแม่ฟ้าหลวง-->
                <!--                    </td>-->
                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="2 " width="10%" align="right"></td>-->
                <!--                    <td>(วันจันทร์ – ศุกร์ เวลา 09.00 – 16.30 น.)  โทรศัพท์  0-5391-6174</td>-->
                <!--                  </tr>-->
                <!--                </table>-->

                <!--                <table v-if="th==0" align="center" width="70%" border="0">-->
                <!--                  <tr><td colspan="3">&nbsp;&nbsp;</td></tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="3" align="center"><font color="red" size="+2">The system has been opened </font></td>-->
                <!--                  </tr>-->
                <!--                  <tr><td colspan="3">&nbsp;&nbsp;</td></tr>-->
                <!--                  <tr>-->
                <!--                    <td width="5%" align="right">1.</td>-->
                <!--                    <td colspan="2">&nbsp;For more information about the rehearsal days. (Monday-Friday during 08.00-16.00-->
                <!--                      p.m.)-->
                <!--                    </td>-->

                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="2 " width="10%" align="right">1.1</td>-->
                <!--                    <td>&nbsp;Student Development Affairs Division Tel. 0-5391-6377, 0-5391-6360</td>-->
                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="2 " width="10%" align="right">1.2</td>-->
                <!--                    <td>&nbsp;Global Relations Division (GRD) Tel. 0-5391-6024 E-mail:yaowapa.pho@mfu.ac.th</td>-->
                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td width="5%" align="right">2.</td>-->
                <!--                    <td colspan="2 ">&nbsp;Degree Certificate (Monday-Friday during 08.00-16.00 p.m.)</td>-->
                <!--                  </tr>-->
                <!--                  <tr>-->
                <!--                    <td colspan="2 " width="10%" align="right">2.2</td>-->
                <!--                    <td>Registrar Division Tel. 0-5391-6433, 0-5391-6546, 0-5391-6547</td>-->
                <!--                  </tr>-->
                <!--                </table>-->
                <!--                <br><br>-->

                <b-card header-class="redmfu1" v-if="th==1">
                  <div slot="header"><strong>คำชี้แจงและขั้นตอนการใช้งาน</strong><br>
                    ระบบแจ้งความประสงค์เข้ารับปริญญาบัตร ประจำปีการศึกษา 2567 มหาวิทยาลัยแม่ฟ้าหลวง<br>
                  </div>
<!--                  <div slot="header"><strong>-->
<!--                    ปิดการใช้งานระบบแจ้งความประสงค์เข้ารับปริญญาบัตร ประจำปีการศึกษา 2567 มหาวิทยาลัยแม่ฟ้าหลวง<br></strong>-->
<!--                  </div>-->
                  <b-card-body>
<!--                    <b-row>-->
<!--                      <b-col sm="1"></b-col>-->
<!--                      <b-col sm="10">-->
<!--                        <strong>-->
<!--                      ติดต่อฝ่ายฝึกซ้อมบัณฑิต พิธีพระราชทานปริญญาบัตร ประจำปีการศึกษา 2567 โทรศัพท์ 053-916377 วันจันทร์ - ศุกร์ เวลา 08.00 - 16.00 น.-->
<!--                        </strong>-->
<!--                      </b-col>-->
<!--                      <b-col sm="1"></b-col>-->
<!--                    </b-row>-->
                  <b-row>
                    <b-col sm="12">
                      1. ให้ผู้สำเร็จการศึกษา รุ่นปีการศึกษา 2567
                      แจ้งความประสงค์เข้ารับและไม่เข้ารับ พระราชทานปริญญาบัตร ประจำปีการศึกษา 2567 โดย
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="2"></b-col>
                    <b-col sm="10">
                      <font color="green">
                        <div align="left">การกรอกรหัสผู้ใช้งาน (Username) เป็น “รหัสนักศึกษา” เช่น “4731402006”<br>
                          และรหัสผ่าน (Password) เป็น “วันเดือนปีคศ.เกิด” ในรูปแบบ วันเดือนตัวย่อภาษาอังกฤษ<br>
                          (ตัวแรกเป็นตัวอักษรพิมพ์ใหญ่) ปีคริสต์ศักราช เช่น “18Nov1985”<br>
                          โดยไม่ต้องเว้นวรรค และคลิกปุ่ม Login
                        </div>
                      </font></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12"> 2. ระบบแจ้งความประสงค์เข้ารับปริญญาบัตร ประกอบด้วยแบบสอบถาม 3 ส่วน ดังนี้<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;ชุดที่ 1 แบบสอบถามภาวะการมีงานทำของบัณฑิต<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;ชุดที่ 2 แบบประเมินตนเองของบัณฑิตต่อทักษะแห่งอนาคต<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;ชุดที่ 3 การแจ้งความประสงค์เข้ารับพระราชทานปริญญาบัตร <br><br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <div align="center"><font color="red">โดยขอความร่วมมือกรอกข้อความให้ครบถ้วน
                        ถูกต้องตามความเป็นจริง<br>
                        เพื่อประโยชน์ต่อการพัฒนาคุณภาพและมาตรฐานของการเรียนการสอน<br>
                        และพัฒนาคุณภาพบัณฑิตของมหาวิทยาลัยแม่ฟ้าหลวง</font></div>
                      <br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">3. พิมพ์แบบรายงานตัวเข้ารับการฝึกซ้อมและรับพระราชทานปริญญาบัตรและนำส่งในวันรายงานตัว
                      เข้าซ้อมรับพระราชทานปริญญาบัตร

                      <br><br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      4. สามารถแจ้งความประสงค์การเข้ารับพระราชทานปริญญาบัตรตั้งแต่ 6-31 มกราคม 2569<br><br>
                    </b-col>
                  </b-row>
                    <b-card>
                      <b-card-body>
                        <b-row class="bg-"><br>
                        </b-row>
                        <b-row>
                          <b-col lg="3">
                          </b-col>
                          <b-col lg="6">
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text>
                                  <i class="icon-user"></i>
                                </b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input
                                id="current_username"
                                v-model="current_username"
                                type="text"
                                class="form-control"
                                placeholder=" Username = “student ID” (for example, 4731402006)"
                                autocomplete="current_username"
                                maxlength="10"
                                :state="validation_user"
                              />
                              <b-form-invalid-feedback :state="validation_user">
                                Your Username must be 10 characters long.<br>
                                Username = “student ID” (for example, 4731402006)
                              </b-form-invalid-feedback>
                              <b-form-valid-feedback :state="validation_user">
                                Correct.
                              </b-form-valid-feedback>
                            </b-input-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text>
                                  <i class="icon-lock"></i>
                                </b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input
                                id="current_password"
                                v-model="current_password"
                                type="password"
                                class="form-control"
                                placeholder=""
                                autocomplete="current_password"
                              />
                              <b-form-invalid-feedback :state="validation_password">
                                Your Password must be 9 characters long.<br>
                                Password = “date of birth” (for example, 08Nov1985) <br>
                                *Month must be the first 3 letters of your birth month.<br>
                                The first letter must be capitalized.<br>
                                The year of birth must be in Christian era and there is no space between letters.
                              </b-form-invalid-feedback>
                              <b-form-valid-feedback :state="validation_password">
                                Correct.
                              </b-form-valid-feedback>
                            </b-input-group>
                          </b-col>
                          <b-col lg="3">
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="3">
                          </b-col>
                          <b-col lg="6"><div align="center">
                            <b-button variant="success" class="px-4" @click="onSubmit">Login</b-button> &nbsp;&nbsp;
                            <b-button variant="warning" class="px-4" @click="onCancel">Cancel</b-button></div>
                          </b-col>
                          <b-col lg="3">
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>

                      <b-card-footer class="redmfu2">
                        <div align="center">
<!--                          <font-->
<!--                          color="red">**กรณีมีปัญหาเกี่ยวกับการแจ้งความประสงค์เข้ารับปริญญาบัตร-->
<!--                          และการเข้าใช้งานระบบ โปรดติดต่อ admins@mfu.ac.th** </font>-->
<!--                        <br>-->
                        <a href="#/search"
                           target="_blank">
                          ค้นหารายชื่อผู้มีสิทธิ์ขึ้นรับพระราชทานปริญญาบัตร และสถิติการแจ้งความประสงค์ฯ ประจำปีการศึกษา
                          2567<br>
                          (Graduation checklist for the Commencement Ceremony)
                        </a></div>
                      </b-card-footer>
                  </b-card-body>
                </b-card>


                <b-card header-class="redmfu1" v-else>
                  <div slot="header"><strong>The Commencement Ceremony Registration System for academic year
                    2024</strong><br>
                  </div>
                  <b-card-body  >
                    <b-row>
                      <b-col sm="1"></b-col>
                      <b-col sm="10" align="center">
                        <strong>
                          MFU Commencement Ceremony for the Academic Year 2024 <br>Tel.053-916377 Monday - Friday (Except public holidays) 8 a.m. - 4 p.m.
                          <br></strong>
                      </b-col>
                      <b-col sm="1"></b-col>
                    </b-row>

                  <b-row>
                    <b-col sm="12"> All graduates please confirm your intention to attend ( or not) the Mae Fah Luang
                      University<br>
                      Commencement Ceremony for the academic year 2024 through the Commencement Ceremony<br>
                      Registration System during 6 -31 January 2026
                      <br><strong>Instruction</strong>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      1. Use student ID number as your username : xxxxxxxxxx, for example “4731402001”<br>
                      Use date of birth as your password (DateMonthYear), for example “01Jan1992”<br>
                     <font color="green"><strong> Remark<br></strong>
                      &nbsp;&nbsp;&nbsp;&nbsp;- The first letter of the month of birth must be a capital letter.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;- The year of birth must be in Christian era.<br>
                       &nbsp;&nbsp;&nbsp;&nbsp;- There is no space between the date, month and year.<br><br></font>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      2. All graduates must complete 3 parts of questionnaires:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Part 1: Graduate Employability Survey<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Part 2: Graduates’ Self-Assessment of Future Skills<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Part 3: The confirmation form to participate in the Rehearsal and
                      Commencement Ceremony<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;academic
                      year 2024<br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12"><div align="center"><font color="red">Therefore, the University would like to request your
                      cooperation in responding to the Graduate<br>
                      Employability Survey with the correct and complete information. Your responses to the
                      survey<br>
                      will result in sending commencement ceremony documents.</font></div>
                      <br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">    3. Please click “ submit” and print out “The confirmation form to participate in the Rehearsal
                      and<br>
                      Commencement Ceremony academic year 2024” on the last page.
                      <br><br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">  4. You have to present “ The confirmation form to participate in the Rehearsal and
                      Commencement<br>
                      Ceremony academic year 2024” paper to the staff on the first rehearsal day.<br><br>
                    </b-col>
                  </b-row>
                    <b-card>
                      <b-card-body>
                        <b-row class="bg-"><br>
                        </b-row>
                        <b-row>
                          <b-col lg="3">
                          </b-col>
                          <b-col lg="6">
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text>
                                  <i class="icon-user"></i>
                                </b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input
                                id="current_username"
                                v-model="current_username"
                                type="text"
                                class="form-control"
                                placeholder=" Username = “student ID” (for example, 4731402006)"
                                autocomplete="current_username"
                                maxlength="10"
                                :state="validation_user"
                              />
                              <b-form-invalid-feedback :state="validation_user">
                                Your Username must be 10 characters long.<br>
                                Username = “student ID” (for example, 4731402006)
                              </b-form-invalid-feedback>
                              <b-form-valid-feedback :state="validation_user">
                                Correct.
                              </b-form-valid-feedback>
                            </b-input-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text>
                                  <i class="icon-lock"></i>
                                </b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input
                                id="current_password"
                                v-model="current_password"
                                type="password"
                                class="form-control"
                                placeholder=""
                                autocomplete="current_password"
                              />
                              <b-form-invalid-feedback :state="validation_password">
                                Your Password must be 9 characters long.<br>
                                Password = “date of birth” (for example, 08Nov1985) <br>
                                *Month must be the first 3 letters of your birth month.<br>
                                The first letter must be capitalized.<br>
                                The year of birth must be in Christian era and there is no space between letters.
                              </b-form-invalid-feedback>
                              <b-form-valid-feedback :state="validation_password">
                                Correct.
                              </b-form-valid-feedback>
                            </b-input-group>
                          </b-col>
                          <b-col lg="3">
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="3">
                          </b-col>
                          <b-col lg="6"><div align="center">
                            <b-button variant="success" class="px-4" @click="onSubmit">Login</b-button> &nbsp;&nbsp;
                            <b-button variant="warning" class="px-4" @click="onCancel">Cancel</b-button></div>
                          </b-col>
                          <b-col lg="3">
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>





<!--                  <b-row>-->
<!--                    <b-col sm="12" class="">  <div align="center"><font-->
<!--                      color="red">**If you have any question regarding to the system, please contact-->
<!--                      admins@mfu.ac.th** </font></div>-->
<!--                    </b-col>-->
<!--                  </b-row>-->
<!--                    <b-row class="bg-gray-100">-->
<!--                      <b-col><br>-->
<!--                        <div align="center"><strong>-->
<!--                          <a href="#/search"-->
<!--                             target="_blank">-->
<!--                            ค้นหารายชื่อผู้มีสิทธิ์ขึ้นรับพระราชทานปริญญาบัตร และสถิติการแจ้งความประสงค์ฯ ประจำปีการศึกษา-->
<!--                            2566<br>-->
<!--                            (Graduation checklist for the Commencement Ceremony)-->
<!--                          </a>-->
<!--                          <br>&nbsp;<br>-->
<!--                        </strong></div>-->
<!--                      </b-col>-->
<!--                    </b-row>-->
                    <b-card-footer class="redmfu2">
                      <div align="center">
<!--                        <font-->
<!--                        color="red">**If you have any question regarding to the system, please contact-->
<!--                        admins@mfu.ac.th**</font>-->
<!--                        <br>-->
                        <a href="#/search"
                           target="_blank">
<!--                          ค้นหารายชื่อผู้มีสิทธิ์ขึ้นรับพระราชทานปริญญาบัตร และสถิติการแจ้งความประสงค์ฯ ประจำปีการศึกษา-->
<!--                          2566<br>-->
                          Graduation checklist for the Commencement Ceremony
                        </a>
                      </div>
                    </b-card-footer>


                  </b-card-body>
                </b-card>

<!--                <b-row>-->
<!--                  <b-col lg="1">-->
<!--                  </b-col>-->
<!--                  <b-col lg="10">-->
<!--                    <div>-->
<!--                      <div align="center"><strong><h5>The Commencement Ceremony Registration System for academic year-->
<!--                        2022 </h5><br>-->
<!--                        <br>-->
<!--                      </strong></div>-->
<!--                      All graduates please confirm your intention to attend ( or not) the Mae Fah Luang University<br>-->
<!--                      Commencement Ceremony for the academic year 2022 through the Commencement Ceremony<br>-->
<!--                      Registration System during 2- 31 January 2024-->
<!--                      <br><strong>Instruction</strong>-->
<!--                      <br>-->
<!--                      <font color="#00018b"><br>-->
<!--                        1. Use student ID number as your username : xxxxxxxxxx, for example “4731402001”<br>-->
<!--                        Use date of birth as your password (DateMonthYear), for example “01Jan1992”<br>-->
<!--                        Remark<br>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;- The first letter of the month of birth must be a capital letter.<br>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;- The year of birth must be in Christian era.<br>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;- There is no space between the date, month and year.<br><br>-->
<!--                        2. All graduates must complete 3 parts of questionnaires:<br>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;Part 1: Graduate Employability Survey<br>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;Part 2: Graduates’ Self-Assessment of Future Skills<br>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;Part 3: The confirmation form to participate in the Rehearsal and-->
<!--                        Commencement Ceremony<br>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;academic-->
<!--                        year 2022<br><br>-->
<!--                        <div align="center"><font color="red">Therefore, the University would like to request your-->
<!--                          cooperation in responding to the Graduate<br>-->
<!--                          Employability Survey with the correct and complete information. Your responses to the-->
<!--                          survey<br>-->
<!--                          will result in sending commencement ceremony documents.</font></div>-->
<!--                        <br><br>-->

<!--                        3. Please click “ submit” and print out “The confirmation form to participate in the Rehearsal-->
<!--                        and<br>-->
<!--                        Commencement Ceremony academic year 2022” on the last page.-->
<!--                        <br><br>-->
<!--                        4. You have to present “ The confirmation form to participate in the Rehearsal and-->
<!--                        Commencement<br>-->
<!--                        Ceremony academic year 2022” paper to the staff on the first rehearsal day.<br><br>-->
<!--                        <div align="center"><font-->
<!--                          color="red">**If you have any question regarding to the system, please contact-->
<!--                          admins@mfu.ac.th** </font></div>-->
<!--                      </font>-->
<!--                    </div>-->
<!--                  </b-col>-->
<!--                  <b-col lg="1">-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row class="bg-gray-100">-->
<!--                  <b-col><br>-->
<!--                    <div align="center"><strong>-->
<!--                      <a href="#/search"-->
<!--                         target="_blank">-->
<!--                        ค้นหารายชื่อผู้มีสิทธิ์ขึ้นรับพระราชทานปริญญาบัตร และสถิติการแจ้งความประสงค์ฯ ประจำปีการศึกษา-->
<!--                        2566<br>-->
<!--                        (Graduation checklist for the Commencement Ceremony)-->
<!--                      </a>-->
<!--                      <br>&nbsp;<br>-->
<!--                    </strong></div>-->
<!--                  </b-col>-->
<!--                </b-row>-->
                <b-card header-class="redmfu1">
                  <div slot="header"><strong>
                    <font color="white">จองภาพถ่าย พิธีพระราชทานปริญญาบัตร (เปิดระบบ ในวันที่ 15 มกราคม 2569)<br>
                      Commencement Ceremony Photo Reservation.
                      (System will be start from 15 January 2026 onwards)</font>
                  </strong><br>
                  </div>
                  <b-card-body>
                    <b-row>
                      <b-col sm="1"></b-col>
                      <b-col sm="10">
                        <strong>คลิกเข้าสู่ระบบ / click to access system</strong>&nbsp;&nbsp;<a href="https://mfugradphoto.com/" target="_blank">https://mfugradphoto.com</a>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;สอบถามรายละเอียดการจองภาพถ่ายพิธีพระราชทานรับปริญญาบัตรเพิ่มเติม ที่สมาคมนักศึกษาเก่ามหาวิทยาลัยแม่ฟ้าหลวง
                        <br>(วันจันทร์ – ศุกร์ เวลา 09.00 – 16.30 น.)
<!--                        โทรศัพท์  0-5391-6174-->

                        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;For more information on booking your commencement ceremony photo,
                        <br>please contact the MFU Alumni Association during office hours: Monday-Friday, 09.00-16.30 hrs.
<!--                        or Tel. 0-5391-6174-->
<!--                        <br><a href="https://mfugradphoto.com/"  target="_blank">https://mfugradphoto.com/</a>-->
                      </b-col>
                      <b-col sm="1">&nbsp;&nbsp;
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
<!--                <b-row class="redmfu1">-->
<!--                  <b-col><br>-->
<!--                    <div align="center"><strong>-->
<!--                      <a href="https://mfu-alumni-shop.appspot.com/s/photobooking"-->
<!--                         target="_blank">-->
<!--                        <font color="white">ระบบลงทะเบียนจองภาพถ่าย พิธีพระราชทานปริญญาบัตร<br>-->
<!--                          (Commencement Ceremony Photo Reservation System)</font>-->
<!--                      </a><br>&nbsp;<br>-->
<!--                    </strong></div>-->
<!--                  </b-col>-->
<!--                </b-row>-->

<!--                <b-row class="bg-"><br>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col lg="3">-->
<!--                  </b-col>-->
<!--                  <b-col lg="6">-->
<!--                    <b-input-group>-->
<!--                      <b-input-group-prepend>-->
<!--                        <b-input-group-text>-->
<!--                          <i class="icon-user"></i>-->
<!--                        </b-input-group-text>-->
<!--                      </b-input-group-prepend>-->
<!--                      <b-form-input-->
<!--                        id="current_username"-->
<!--                        v-model="current_username"-->
<!--                        type="text"-->
<!--                        class="form-control"-->
<!--                        placeholder=" Username = “student ID” (for example, 4731402006)"-->
<!--                        autocomplete="current_username"-->
<!--                        maxlength="10"-->
<!--                        :state="validation_user"-->
<!--                      />-->
<!--                      <b-form-invalid-feedback :state="validation_user">-->
<!--                        Your Username must be 10 characters long.<br>-->
<!--                        Username = “student ID” (for example, 4731402006)-->
<!--                      </b-form-invalid-feedback>-->
<!--                      <b-form-valid-feedback :state="validation_user">-->
<!--                        Correct.-->
<!--                      </b-form-valid-feedback>-->
<!--                    </b-input-group>-->
<!--                    <b-input-group>-->
<!--                      <b-input-group-prepend>-->
<!--                        <b-input-group-text>-->
<!--                          <i class="icon-lock"></i>-->
<!--                        </b-input-group-text>-->
<!--                      </b-input-group-prepend>-->
<!--                      <b-form-input-->
<!--                        id="current_password"-->
<!--                        v-model="current_password"-->
<!--                        type="password"-->
<!--                        class="form-control"-->
<!--                        placeholder=""-->
<!--                        autocomplete="current_password"-->
<!--                      />-->
<!--                      <b-form-invalid-feedback :state="validation_password">-->
<!--                        Your Password must be 9 characters long.<br>-->
<!--                        Password = “date of birth” (for example, 08Nov1985) <br>-->
<!--                        *Month must be the first 3 letters of your birth month.<br>-->
<!--                        The first letter must be capitalized.<br>-->
<!--                        The year of birth must be in Christian era and there is no space between letters.-->
<!--                      </b-form-invalid-feedback>-->
<!--                      <b-form-valid-feedback :state="validation_password">-->
<!--                        Correct.-->
<!--                      </b-form-valid-feedback>-->
<!--                    </b-input-group>-->
<!--                  </b-col>-->
<!--                  <b-col lg="3">-->
<!--                  </b-col>-->
<!--                </b-row>-->

<!--                <b-row>-->
<!--                  <b-col lg="3">-->
<!--                  </b-col>-->
<!--                  <b-col lg="6">-->
<!--                    <b-button variant="primary" class="px-4" @click="onSubmit">Login</b-button>-->
<!--                  </b-col>-->
<!--                  <b-col lg="3">-->
<!--                  </b-col>-->
<!--                </b-row>-->

                <!--                  <b-row >-->
                <!--                    <b-col><br>-->
                <!--                    <div align="center">-->
                <!--                    <a href="https://docs.google.com/spreadsheets/d/1_fr28olTtmyfroLMeDc4CyuZnGsqHbJK2iC5auqYug8/edit?usp=sharing" target="_blank">-->
                <!--                      <h5><font color="red"> สำหรับทดสอบระบบ 20-30 พฤศจิกายน 2566-->
                <!--                        <br> -username password-->
                <!--                        <br>-กรอก การแก้ไข หรือ Error ที่พบ</font></h5>-->
                <!--                    </a> </div>-->

                <!--                    </b-col>-->
                <!--                  </b-row>-->

                <!--                <b-row>-->
                <!--                  <div style="float:center;">-->


                <!--                    &lt;!&ndash;                     <Countdown end="02 14 2022"></Countdown>&ndash;&gt;-->
                <!--                    &lt;!&ndash;                     //dd mm yyyy&ndash;&gt;-->
                <!--                  </div>-->
                <!--                </b-row>-->
                <!--                <br/>-->

                <!--                <b-row class="text-danger">****** เฉพาะ ป.ตรี (ไทย+ต่างชาติ) เพิ่มแบบประเมินความพึงพอใจของบัณฑิตต่อทักษะ-->
                <!--                  7 ด้าน******-->
                <!--                </b-row>-->
                <!--                <b-row>-->
                <!--                  <b-col><a-->
                <!--                    href="https://docs.google.com/spreadsheets/d/1l1LI8mcPPFRKGLyj2l6EOK5lI4_dC2J6zLpz60UppkY/edit?usp=sharing"-->
                <!--                    target="_blank">คลิ๊กที่นี่ Username & Password สำหรับเทส</a></b-col>-->
                <!--                </b-row>-->


                <!--   <b-row>
                    <br />1. ขอความอนุเคราะห์ท่านตอบแบบสำรวจภาวะการมีงานทำ<font color=red><u>เพิ่มเติม (จำนวน 4-8 ข้อ)</u></font>เนื่องจากมหาวิทยาลัยได้รับข้อมูลในการสำรวจไม่สมบูรณ์ ซึ่งส่งผลต่อการนำส่งข้อมูลให้สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม
            ทั้งนี้ขอความอนุเคราะห์ข้อมูลภายในวันศุกร์ที่ 13 เมษายน 2563

                     <br />2. การกรอกรหัสผู้ใช้งาน
                     <br />&nbsp&nbsp&nbsp&nbsp Username คือ "รหัสประจำตัวนักศึกษา" (ตัวอย่าง 4731402206)
                     <br />&nbsp&nbsp&nbsp&nbsp Password คือ “วันเดือนปีคศ.เกิด” (ในรูปแบบ วัน 2 อักษร เดือนตัวย่อภาษาอังกฤษ 3 อักษรแรกเท่านั้น
                     <br />โดยตัวอักษรแรกของเดือนเป็นตัวอักษรพิมพ์ใหญ่ ตามด้วยปีคริสตศักราช โดยไม่ต้องเว้นวรรค ตัวอย่างเช่น “01Jan1992” )
                     <br />3. ผู้สำเร็จการศึกษาทานใดไม่สามารถเข้าระบบได้ โปรดติดต่อ
                     planning@mfu.ac.th หรือ 053916033-->

                <!-- <a href="#/Search">
                  Click !! ตรวจสอบรายชื่อผู้มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร
                  <br />Graduation checklist for the Commencement Ceremony
                </a>
              </b-row>
              <b-row>&nbsp&nbsp&nbsp</b-row>
              <b-row>
                <a href="/graduateceremony/img/graduate.xlsx" target="_blank">
                  ไฟล์รายชื่อผู้มีสิทธิ์ขึ้นรับพระราชทานปริญญาบัตร
                  <br />Graduation checklist for the Commencement Ceremony
                </a>
              </b-row> --->

                <b-row>&nbsp&nbsp&nbsp&nbsp</b-row>
                <b-row>
                  <div align="center">
                    <br/>
                    <font color="red">{{ error_txt }}</font><br>
                    <font color="red">{{ error_txt1 }}</font>
                    <br>
                    <br>
                    <font color="green"> {{ error_txt2 }}</font><br>
                    <font color="green">{{ error_txt3 }}</font><br>
                    <font color="green">{{ error_txt4 }}</font><br>
                    <font color="green">{{ error_txt5 }}</font>
                  </div>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
          <!--          <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">-->
          <!--            <b-card-body class="text-center">-->
          <!--              <div >-->
          <!--                <h2>ขั้นตอนการกรอก Username และ Password-->
          <!--                  <br>(How to Enter Username and Password)</h2>-->
          <!--                <p align="left"> **เพื่อการแสดงผลที่ถูกต้อง โปรดใช้ Google Chrome หรือ Firefox**-->
          <!--                  <br>(For a pleasant experience with the system, please use Google Chrome or Firefox)-->
          <!--                  <br>-->

          <!--                  <br>&nbsp&nbsp&nbsp&nbsp<font size="+1"><strong>Username คือ “รหัสนักศึกษา” (เช่น 5731402006)-->
          <!--                    <br>&nbsp&nbsp&nbspPassword คือ “วันเดือนปีคศ.เกิด” (เช่น 08Nov1999) </strong></font>-->

          <!--                  <br><br><strong>Username = student ID (for example, 4731402006) and using date of birth as your and-->
          <!--                    <br>Password = date of birth in DDMnnYYYY format (for example, 18Nov1985)</strong>-->

          <!--                  <br><br>รูปแบบการกรอก Password คือ ระบุวันที่จำนวน 2 หลัก ตามด้วยตัวย่อเดือน-->
          <!--                  <br>โดยตัวแรกเป็นตัวอักษรพิมพ์ใหญ่ และตามด้วยปี ค.ศ. จำนวน 4 หลัก (ไม่ต้องเว้นวรรค)-->


          <!--                  <br><br><strong>Remark:</strong> - Mnn refers to the first 3 letters of birth month. (The first letter must be capitalized.)-->
          <!--                  - YYYY refers to the year of birth in Christian era. There is no space between the date, month and year.-->


          <!--                  <br><br>*กรณีพบปัญหาการเข้าใช้งานระบบ  ติดต่อ admins@mfu.ac.th-->
          <!--                  <br>* If you have any technical issues regarding to the system, please contact admins@mfu.ac.th**</p>-->
          <!--              </div>-->
          <!--              <b-row>-->
          <!--                <b-col><br>-->
          <!--                  <br></b-col>-->
          <!--              </b-row>-->

          <!--              <b-row class="bg-gray-100">-->
          <!--                <b-col><br><a href="#/Reportfaculty_63">-->
          <!--                  <div align="center"><h1>สรุปจำนวนการตอบ</h1></div>-->
          <!--                </a> <br></b-col>-->
          <!--              </b-row>-->
          <!--            </b-card-body>-->
          <!--          </b-card>-->
        </b-card-group>
      </b-col>
    </b-row>

    <b-modal
      title="การเข้าสู่ระบบผิดพลาด (Login failure)"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>

import api from "../../service/api";
import Countdown from "vuejs-countdown";

export default {
  components: {Countdown},
  data() {
    return {
      current_username: "6432301074",
      current_password: "19Jul2001",
      lid: 0,
      error_txt: "",
      error_txt1: "",
      error_txt2: "",
      error_txt3: "",
      error_txt4: "",
      error_txt5: "",
      debt: "",
      thaistudent: "",
      current_postpone: 0,
      th: 0,
      // current_question1: 0,
      // current_question7: 0,
      current_graduatestatus: 0,
      current_poststatus: 0,
      current_pay: 0,
      user: {},
      current_erorrtxt: "",
      dangerModal: false,
      numEror: 0,
    };
  }, computed:
    {
      validation_user() {
        if (this.current_username != null && this.current_username != '' && this.current_username != undefined) {
          if (this.current_username.length == 10) {
            if ((this.current_username <= 6651291011) && (this.current_username >= 5731809090)) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }, validation_password() {
        if (this.current_password != null) {
          if (this.current_password.length == 9) {
            var date_birth0 = this.current_password.substring(0, 2);
            var date_birth1 = this.current_password.substring(0, 1);
            var date_birth3 = this.current_password.substring(1, 2);
            var date_birth = 0;
            if (date_birth1 == 0) {
              date_birth = date_birth3;
            } else {
              date_birth = date_birth0;
            }
            var birth_int = parseInt(date_birth);
            if (Number.isInteger(this.th)) {
              if (birth_int > 31) {
                return false;
              } else {
                return true;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      }
      ,
    },
  methods: {
    setNewToken(student) {
      this.$store.dispatch("setUser", {
        studentid: student.STUDENTID,
        studentcode: student.STUDENTCODE,
        prefixname: student.PREFIXNAME,
        studentname: student.STUDENTNAME,
        studentsurname: student.STUDENTSURNAME,
        studentnameeng: student.STUDENTNAMEENG,
        studentsurnameeng: student.STUDENTSURNAMEENG,
        facltyname: student.FACULTYNAME,
        departmentname: student.DEPARTMENTNAME,
        facltynameeng: student.FACULTYNAMEENG,
        departmentnameeng: student.DEPARTMENTNAMEENG,
        levelgroupname: student.LEVELGROUPNAME,
        levelgroupnameeng: student.LEVELGROUPNAMEENG,
        debt: student.DEBT,
        thaistudent: student.THAI_STUDENT,
        // debt: 500,
        // thaistudent: 1,
        sex: student.SEX,
        citizen: student.CITIZENID,
        levelid: student.LEVELID,
        year: 2567,
        postpone_status: student.current_postpone,
        // question1: this.current_question1,
        // question7: this.current_question7,
        token: student.token,
        work_status: ""
      });
      this.$store.dispatch("setToken", student.token);
      // if (res.data.code == "200") {
      this.debt = this.$store.state.user.debt;
      this.thaistudent = this.$store.state.user.thaistudent;
      this.studentid = this.$store.state.user.studentid;
      this.current_postpone = this.$store.state.user.postpone_status;
      // console.log("user==", this.$store.state.user)
      // console.log("thaistudent==", this.thaistudent)
      api.onSetHeader();
      if (this.current_postpone == 1) {
        this.$router.push("/main70");
      } else {
        if (this.debt != "0.00") {
          this.checkDebt(this.thaistudent, this.debt);
        } else {
          this.getGraduateStatus(student)
         /* if (this.thaistudent == 1) {
            //console.log("11111111111")
            //  this.$router.push("/Con");
            this.$router.push("/main");
          } else {
            //console.log("00000000000")
            // this.$router.push("/General");
            this.$router.push("/main");
          }*/
        }
      }


      if (this.debt != "0.00") {
        // console.log("debt==")
        this.checkDebt(this.thaistudent, this.debt);
      } else {
        // console.log("graduate_status==")
        // this.$router.push("/Read");
        // if (this.$store.state.user.graduate_status == 70) {
        //   this.$router.push("/Regis");
        // } else {
        //   this.$router.push("/General");
        // }
        // console.log("current_postpone==",this.current_postpone)
        // if (this.current_postpone==1){
        //   this.$router.push("/Main70");
        // }else{
        //   this.$router.push("/General");
        // }
      }
      // } else {
      //   // console.log("else==")
      //   this.numEror = this.numEror + 1;
      //   this.error_txt =
      //     "การกรอกรหัสผู้ใช้งาน\n" +
      //     "    Username คือ “รหัสนักศึกษา” (เช่น 4731402006)\n" +
      //     "    Password คือ “วันเดือนปีคศ.เกิด” (เช่น 08Nov1985)\n" +
      //     "รูปแบบการกรอก วันเดือนตัวย่อภาษาอังกฤษ ตัวแรกเป็นตัวอักษรพิมพ์ใหญ่\n" +
      //     "ปีคริสตศักราช โดยไม่ต้องเว้นวรรค";
      //   this.error_txt1 =
      //     "Log in with\n" +
      //     "Username = “student ID” (for example, 4731402006)\n" +
      //     "Password = “date of birth” (for example, 08Nov1985)\n" +
      //     "*Month must be the first 3 letters of your birth month. The first letter must be capitalized. The year\n" +
      //     "of birth must be in Christian era and there is no space between letters.\n"; //<br />
      //   this.error_txt2 =
      //     "ระยะเวลาในกรอกข้อมูล 19 ธันวาคม - 13 มกราคม 2566\n";
      //   this.error_txt3 =
      //     "หากบัณฑิตท่านใดไม่สามารถเข้าระบบได้ ติดต่อ admins@mfu.ac.th\n";
      //   this.error_txt4 =
      //     "Graduates can fill out information from 19 December-13 January 2024.\n"
      //   this.error_txt5 =
      //     "If there are any problems regarding the system, please contact admins@mfu.ac.th\n";
      //
      // }
      // console.log("numEror==",this.numEror)
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
    },

    getGraduateStatus(student) {
      this.numEror = 0;
      api
        .getStudentUserQuestionById(student.STUDENTID)
        .then(res => {
          // console.log("getGraduateStatus==",res.data)
          if (res.data.data.length == 1) {
            this.current_graduatestatus = res.data.data[0].GRADUATE_STATUS;
            this.$router.push("/main");
          } else {
            this.current_graduatestatus = 0
            if (this.thaistudent==1) {
              this.$router.push("/con");
            }else {
              this.$router.push("/main");
            }
          }

          // if (res.data.code == "200") {
          //   this.debt = this.$store.state.user.debt;
          //   this.thaistudent = this.$store.state.user.thaistudent;
          //   this.studentid = this.$store.state.user.studentid;
          //   this.lid = this.$store.state.user.levelid;
          //
          //   if (this.debt != "0.00") {
          //     // console.log("debt==")
          //     this.checkDebt(this.thaistudent, this.debt);
          //   } else {
          //     // console.log("graduate_status==")
          //     // this.$router.push("/Read");
          //     if (this.$store.state.user.graduate_status == 70) {
          //       this.$router.push("/Regis");
          //     } else {
          //       this.$router.push("/General");
          //     }
          //   }
          // } else {
          //   // console.log("else==")
          //   this.numEror = this.numEror + 1;
          //   this.error_txt =
          //     "การกรอกรหัสผู้ใช้งาน\n" +
          //     "    Username คือ “รหัสนักศึกษา” (เช่น 4731402006)\n" +
          //     "    Password คือ “วันเดือนปีคศ.เกิด” (เช่น 08Nov1985)\n" +
          //     "รูปแบบการกรอก วันเดือนตัวย่อภาษาอังกฤษ ตัวแรกเป็นตัวอักษรพิมพ์ใหญ่\n" +
          //     "ปีคริสตศักราช โดยไม่ต้องเว้นวรรค";
          //   this.error_txt1 =
          //     "Log in with\n" +
          //     "Username = “student ID” (for example, 4731402006)\n" +
          //     "Password = “date of birth” (for example, 08Nov1985)\n" +
          //     "*Month must be the first 3 letters of your birth month. The first letter must be capitalized. The year\n" +
          //     "of birth must be in Christian era and there is no space between letters.\n"; //<br />
          //   this.error_txt2 =
          //     "ระยะเวลาในกรอกข้อมูล 19 ธันวาคม - 13 มกราคม 2566\n";
          //   this.error_txt3 =
          //     "หากบัณฑิตท่านใดไม่สามารถเข้าระบบได้ ติดต่อ admins@mfu.ac.th\n";
          //   this.error_txt4 =
          //     "Graduates can fill out information from 19 December-13 January 2024.\n"
          //   this.error_txt5 =
          //     "If there are any problems regarding the system, please contact admins@mfu.ac.th\n";
          //
          // }
          // // console.log("numEror==",this.numEror)
          // if (this.numEror == 0) {
          //   this.dangerModal = false;
          // } else {
          //   this.dangerModal = true;
          // }

        })
        .catch(err => {
          console.log("getStatus==", err.toString());
        });
    },
    checkPostpone(student) { //เลื่อนรับปริญญา
      api
        .getPostpone(student.STUDENTID)
        //.getSlip(student.STUDENTID)
        .then(res => {
          // console.log("getPostpone==", res.data.data)
          if (res.data.data.length == 1) {
            this.current_postpone = 1;
            student.current_postpone = 1;
          } else {
            this.current_postpone = 0;
            student.current_postpone = 0;
          }
          // console.log("student==", student)
          this.setNewToken(student);

        })
        .catch(err => {
          console.log("checkPostpone", err.toString());
        });
    },
    getToken(studentcode, birthday) {
      api
        .apilogin(studentcode, birthday)
        .then(res => {
          // console.log("getToken==",res.data)
          if (res.data.status == 'fail') {
            this.numEror = this.numEror + 1;
            this.error_txt = res.data.msg
            if (this.numEror == 0) {
              this.dangerModal = false;
            } else {
              this.current_erorrtxt = this.error_txt
              this.dangerModal = true;
            }
          } else {
           this.checkPostpone(res.data);

          }
        })
        .catch(err => {
          console.log("getToken", err.toString());
          this.actionUpdate = false;
        });
    },
    checkDebt(thai_student, debt) {
      if (debt != "0.00") {
        this.numEror = 1;
        if (thai_student == 1) {
          this.error_txt =
            "ท่านมีหนี้สินค้างชำระต่อมหาวิทยาลัย จำนวน " +
            debt +
            " บาท ";
          this.error_txt1 = "โปรดดำเนินการชำระเงินให้เรียบร้อย";
          this.error_txt2 =
            " ก่อนดำเนินการแจ้งความประสงค์การเข้ารับพระราชทานปริญญาบัตร";
          this.error_txt3 =
            "กรุณาติดต่อส่วนการเงินและบัญชี Tel. 0 5391 6016";
        } else {
          this.error_txt =
            "You have overdue debts to the university " +
            debt +
            " baht ";
          this.error_txt2 =
            "Please make a payment before the confirmation of intention to attend";
          this.error_txt3 = "(or not) the MFU commencement ceremony.";
          this.error_txt4 =
            "Please contact Division of Financial and Accounting  Tel. 0 5391 6016";

        }
        if (this.numEror == 0) {
          this.dangerModal = false;
        } else {
          this.current_erorrtxt = this.error_txt + this.error_txt2 + this.error_txt1 + this.error_txt3 + this.error_txt4
          this.dangerModal = true;
        }
      }
    },
    /* getCurrentStudent(studentid) {
       api
         .getQuestionaireStatus(studentid)
         .then(res => {
           // console.log("getQuestionaireStatus==", res);
           if (res.data.data.length > 0) {
             this.current_question1 = res.data.data[0].QUESTIONNAIRE_1;
             if (this.current_question1 == null) {
               this.current_question1 = 0;
             } else {
               this.current_question1 = this.current_question1;
             }
             this.current_question7 = res.data.data[0].QUESTIONNAIRE_7;
             if (this.current_question7 == null) {
               this.current_question7 = 0;
             } else {
               this.current_question7 = this.current_question7;
             }
             this.current_graduatestatus = res.data.data[0].GRADUATE_STATUS;
             if (this.current_graduatestatus == null) {
               this.current_graduatestatus = 0;
             } else {
               this.current_graduatestatus = this.current_graduatestatus;
             }
             this.current_poststatus = res.data.data[0].POST_STATUS;
             if (this.current_poststatus == null) {
               this.current_poststatus = 0;
             } else {
               this.current_poststatus = this.current_poststatus;
             }
           } else {
             this.current_question1 = 0;
             this.current_question7 = 0;
             this.current_graduatestatus = 0;
           }
           if (this.levelid == 3) { // ปอตรี
             if ((this.current_question1 == 1) && (this.current_question7 == 1)) {
               this.$router.push("/Dashboard_63");
             } else if ((this.current_question1 == 1) && (this.current_question7 == 0)) {
               this.$router.push("/Part7");
             } else if ((this.current_question1 == 0) && (this.current_question7 == 0)) {
               this.$router.push("/General");
             } else {
               this.$router.push("/General");
             }
           } else {

             if (this.current_question1 == 1) {
               // console.log("โท เอก")
               this.$router.push("/Dashboard_63");
             } else {
               this.$router.push("/General");
             }
           }
         })
         .catch(err => {
           console.log("getCurrentStudent", err.toString());
           //  this.$router.push("login");
         });
     },*/
    onCancel(){
      this.current_username="";
      this.current_password="";
    },

    onSubmit() {
      if (this.current_username != "" && this.current_password != "") {
        this.getToken(this.current_username, this.current_password);
      } else {
        this.numEror = this.numEror + 1;
        this.error_txt =
          "- การกรอกรหัสผู้ใช้งาน\n" +
          "    Username คือ “รหัสนักศึกษา” (เช่น 4731402006)\n" +
          "    Password คือ “วันเดือนปีคศ.เกิด” (เช่น 08Nov1985)\n" +
          "รูปแบบการกรอก วันเดือนตัวย่อภาษาอังกฤษ ตัวแรกเป็นตัวอักษรพิมพ์ใหญ่\n" +
          "ปีคริสตศักราช โดยไม่ต้องเว้นวรรค";
        this.error_txt1 =
          "Log in with\n" +
          "Username = “student ID” (for example, 4731402006)\n" +
          "Password = “date of birth” (for example, 08Nov1985)\n" +
          "*Month must be the first 3 letters of your birth month. The first letter must be capitalized. The year\n" +
          "of birth must be in Christian era and there is no space between letters.\n"; //<br />&nbsp&nbsp&nbsp&nbsp
        this.error_txt2 =
          "ระยะเวลาในกรอกข้อมูล 11-14 กุมภาพันธ์ 2565\n";
        this.error_txt3 =
          "หากบัณฑิตท่านใดไม่สามารถเข้าระบบได้ ติดต่อ admins@mfu.ac.th\n";
        this.error_txt4 =
          "Graduates can fill out information from 11-14 Febuary 2022.\n";
        this.error_txt5 =
          "If there are any problems regarding the system, please contact admins@mfu.ac.th\n";
        this.numEror = 1;


        this.current_erorrtxt =
          "-การกรอกรหัสผู้ใช้งาน\n" +
          "    Username คือ “รหัสนักศึกษา” (เช่น 4731402006)\n" +
          "    Password คือ “วันเดือนปีคศ.เกิด” (เช่น 08Nov1985)\n" +
          "-Log in with" +
          "Username = “student ID” (for example, 4731402006)\n" +
          "Password = “date of birth” (for example, 08Nov1985)\n";
      }
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
    }
  },

  created() {
    this.th = parseInt(this.$route.query.th);
    if (!Number.isInteger(this.th)) {
      this.th = 0;
    }

    // this.studentid = this.$store.state.user.studentid;
    // console.log("th=",this.th)
    // this.getCurrentStudent(this.studentid);
  }
}
;
</script>
<style>
.redmfu1 {
  background-color: #c93632;
  color: white;
}
.redmfu2 {
  background-color: #f8f5f0;
  color: white;
}.blue-text {
   color: blue;
 }

</style>
